export default __webpack_public_path__ + "static/breadcrumbs-size-do-22df3f28846af33be4e4ca75f2c85cab.png";